import { Moon } from 'lunarphase-js';

export function generateMoonPhases(year, hemisphere) {
  const phases = [];
  const moonIcons = {
    'New': '🌑 Luna nueva',
    'First Quarter': '🌓 Luna creciente',
    'Full': '🌕 Luna llena',
    'Last Quarter': '🌗 Luna menguante',
};

const tasks = {
    'New': 'Descanso del suelo zZzZ / Poda mantenimiento ✂️ / Control de Plagas 🐛',
    'First Quarter': 'Germinación / Siembra / Transplante 🌱',
    'Full': 'Descanso del suelo zZzZ / Cosecha 🌷',
    'Last Quarter': 'Esquejes 🌱 - Podas ✂️ / Control de Plagas 🐛',
};

const abonoTasks = {
    crecimiento: 'Fertilización por riego a tierra 💧',
    floracion: 'Fertilización por riego foliar 🌸',
};

  for (let month = 0; month < 12; month++) {
    for (let day = 1; day <= 31; day++) {
      const date = new Date(year, month, day);

      // Validar la fecha (por ejemplo, evitar días inválidos como el 31 en febrero)
      if (date.getMonth() !== month) break;

      // Calcular la fase lunar para la fecha actual
      const phase = Moon.lunarPhase(date);

      // Ajustar fase según hemisferio
      let adjustedPhase = phase;
      if (hemisphere === 'north') {
        if (phase === 'First Quarter') adjustedPhase = 'Last Quarter';
        else if (phase === 'Last Quarter') adjustedPhase = 'First Quarter';
      }

      // Registrar fases lunares
      if (moonIcons[adjustedPhase]) {
        phases.push({
          title: `${moonIcons[adjustedPhase]} - ${tasks[adjustedPhase]}`,
          date: date.toISOString().split('T')[0], // Guardar fecha sin hora
        });
      }

      // **Lógica para actividades adicionales**
      if (adjustedPhase === 'Last Quarter') {
        // Abono de Crecimiento y Transplante inicial
        phases.push({
          title: abonoTasks.crecimiento,
          date: date.toISOString().split('T')[0],
        });
        // phases.push({
        //   title: 'Transplante inicial 🌱 (Fase Creciente)',
        //   date: date.toISOString().split('T')[0],
        // });
      }

      if (adjustedPhase === 'First Quarter' || adjustedPhase === 'Full') {
        // Abono de Floración y Cosecha
        phases.push({
          title: abonoTasks.floracion,
          date: date.toISOString().split('T')[0],
        });
        // phases.push({
        //   title: 'Cosecha 🌾 (Luna Menguante)',
        //   date: date.toISOString().split('T')[0],
        // });
      }
    }
  }

  return phases;
}
